import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './segment.styles';
export interface SegmentOption {
  value: string;
  label: ComponentChildren;
}
interface SegmentProps {
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
  /** Full-width: stretches each option equally (the prototype `.seg2`). */
  block?: boolean;
  /** Active option uses the accent colour instead of the default text colour. */
  accentActive?: boolean;
}
export function Segment({
  options,
  value,
  onChange,
  block = false,
  accentActive = false
}: SegmentProps) {
  return <div role="group" {...stylex.props(styles.seg, block && styles.segBlock)}>
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" aria-pressed={active} onClick={() => onChange(o.value)} {...stylex.props(styles.btn, block && styles.btnBlock, active && (accentActive ? styles.btnActiveAccent : styles.btnActive))}>
            {o.label}
          </button>;
    })}
    </div>;
}